// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__16-SU","range":"MonthRangeSwitch_range__1lLD7","disabled":"MonthRangeSwitch_disabled__3ZOeb"};